document.addEventListener("DOMContentLoaded", () => {
  const customBtn = document.querySelector("#custom-buy-now-btn");
  const variantInput = document.querySelector(".product-variant-id");

  if (!customBtn || !variantInput) return;

  customBtn.addEventListener("click", () => {
    const variantId = variantInput.value;

    if (!variantId) return;

    customBtn.disabled = true;
    customBtn.textContent = "Procesando...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((res) => res.json())
      .then(() => {
        // 👇 Redirige al checkout inmediatamente después de agregar
        window.location.href = "/checkout";
      })
      .catch((err) => {
        console.error("Error al agregar al carrito:", err);
        customBtn.disabled = false;
        customBtn.textContent = "Intentar nuevamente";
      });
  });
});
